<div class="well">
    <h5>WAPC</h5>
    <div class="row">
        <div class="col-xs-3">
            <label class="control-label required-input">Planning approval</label>
            <div
                [ngClass]="{'has-radio-error': !isPlanningApprovalOptionValid() && submitted}"
                ng-class="{'has-radio-error': fieldRecordWapcForm['planningApproval' + $index].$invalid
                            && (fieldRecordWapcForm['planningApproval' + $index].$dirty || fieldRecordWapcForm.$submitted)}">
                <div>
                    @for (planningApprovalOption of planningApprovalOptions; track planningApprovalOption; let i = $index) {
                        <label class="nlr-radio">
                            <input
                                #planningApproval="ngModel"
                                type="radio"
                                name="planningApproval"
                                [value]="planningApprovalOption.value"
                                [(ngModel)]="model.planningApproval"
                                (ngModelChange)="onPlanningApprovalChange(planningApprovalOption.value, planningApproval)"
                                required />
                            <span>{{planningApprovalOption.name}}</span>
                        </label>
                    }
                </div>
            </div>
        </div>
        @if (model.planningApproval === 'Yes') {
            <div class="col-xs-4">
                <label
                    class="control-label"
                    [ngClass]="{'required-input': isPlanningAuthorityReferenceRequired()}">
                    Planning authority reference
                </label>
                <div
                    class="input-group"
                    [ngClass]="{'has-error': submitted && !planningAuthorityReference.valid}">
                    <span class="input-group-addon">
                        <i class="nlrp-icon nlrp-icon-edit"></i>
                    </span>
                    <input
                        type="text"
                        #planningAuthorityReference="ngModel"
                        name="planningAuthorityReference"
                        id="planningAuthorityReference"
                        class="form-control"
                        [(ngModel)]="referenceNumber"
                        (ngModelChange)="onReferenceChange($event, planningAuthorityReference)"
                        nlrPattern="[^,]*$"
                        [required]="isPlanningAuthorityReferenceRequired()" />
                </div>
                @if (planningAuthorityReference.errors?.nlrPattern && planningAuthorityReference | formFieldHasError) {
                    <div class="help-block">
                        <span>Error!</span>
                        <span>Invalid.</span>
                    </div>
                }
            </div>
        }
    </div>
</div>
